import { useEffect, useState } from 'react';
import Icon from '@mdi/react';
import { mdiHelpCircleOutline } from '@mdi/js';
import { useSupportDrawer } from '@stores';

interface SupportButtonProps {
  className?: string;
}

const SupportButton = ({ className = '' }: SupportButtonProps) => {
  const { currentView, openDrawer } = useSupportDrawer();
  const [showPulse, setShowPulse] = useState(true);
  const [pulseCount, setPulseCount] = useState(0);

  const isExpanded = currentView === 'tooltip';

  // Stop pulse animation after 3 pulses or user interaction
  useEffect(() => {
    if (pulseCount >= 3 || currentView !== 'closed') {
      setShowPulse(false);
    }
  }, [pulseCount, currentView]);

  // Count pulses
  useEffect(() => {
    if (!showPulse) return;

    const interval = setInterval(() => {
      setPulseCount((prev) => prev + 1);
    }, 2000);

    return () => clearInterval(interval);
  }, [showPulse]);

  const handleClick = () => {
    setShowPulse(false);
    openDrawer();
  };

  return (
    <button
      type='button'
      className={`support-fab ${showPulse ? 'support-fab--pulse' : ''} ${className}`}
      onClick={handleClick}
      aria-label='Open support options'
      aria-expanded={isExpanded}
      aria-controls='support-tooltip'
      aria-haspopup='dialog'
    >
      <Icon path={mdiHelpCircleOutline} size={1} aria-hidden='true' />
      <span className='support-fab__text'>Need Help?</span>
    </button>
  );
};

export default SupportButton;
